import { FC, ReactNode } from 'react';
import { Heading } from 'src/components/heading';
import { Stack } from 'src/components/stack';
import styled from 'styled-components';

export const SidebarSections = styled(Stack).attrs({ gap: 2.5, flow: 'row' })`
  padding-left: 1rem;
`;

export const SidebarSection: FC<{ title: string; children: ReactNode }> = ({
  children,
  title,
}) => {
  return (
    <div>
      <Heading mode="sidebar" style={{ paddingRight: '1rem' }}>
        {title}
      </Heading>
      {children}
    </div>
  );
};
